export default "__VITE_ASSET__DQ6wz4Mq__"